<template>
    <div :id="page_slug">

        <div class="crumbs-bar">
            <el-row>
                <el-col :span="12">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ name: 'DashboardPage' }">Dashboard</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ name: 'ProductTagList' }">Tag</el-breadcrumb-item>
                    <el-breadcrumb-item>Add</el-breadcrumb-item>
                </el-breadcrumb>        
                </el-col>      
            </el-row>
        </div>

        <el-form
            ref="tag"
            :rules="rules.tag"
            :model="tag"
            :label-position="label_position">

            <el-form-item label="Name" prop="name">
                <el-input v-model="tag.name"></el-input>
            </el-form-item>

            <el-form-item label="Sort Order" prop="sort_order">
                <el-input-number controls-position="right" :min="0" v-model="tag.sort_order" :value="tag.sort_order"></el-input-number>
            </el-form-item>

            <el-form-item label="Is Hidden" prop="tag_is_hidden">
                <el-switch
                    v-model="tag.tag_is_hidden"
                    :active-value="1"
                    :inactive-value="0">
                </el-switch>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="addTag('tag')">Add Tag</el-button>
            </el-form-item>

        </el-form>

        <pre v-if="config.debug">{{$data}}</pre>

    </div>
</template>

<style>

</style>

<script>
    import Config from '@/store/Config.js';
    import Utils from '@/components/utils/Utils.js';

    export default {
        data: function() {
            return {
                page_alias: 'Add Tag',
                page_slug: 'add-tag',

                config: Config.config,

                label_position: 'top',
                loading: false,

                rules: {
                    tag: {
                        name: [
                            {required: true, message: 'Please Enter Corporation Name', trigger: 'blur'}
                        ],
                        sort_order: [
                            {required: true, message: 'Please Enter Sorter Order', trigger: 'blur'},
                        ],
                    }
                },

                tag: {
                    name: '',
                    created_user_id: '',
                    updated_user_id: '',
                    sort_order: '',
                    tag_is_hidden: '',
                },
            };  
        },

        mounted: function() {
            const me = this;
            
        },

        methods: {
            addTag: function(formName) {
                console.log('Add Tag Function');
                const me = this;
                me.$refs[formName].validate((valid) => {
                if (valid) {
                    var jwt = Utils.decodejwt();
                    me.tag.updated_user_id = jwt.sub;
                    me.tag.created_user_id = jwt.sub;
                    me.$http.post(me.config.api + 'productTag', me.tag).then(
                        response => {
                        console.log('Success posting data')  
                        console.log(response.status);
                        console.log(response.statusText);
                        // Success notification 
                        me.$notify({
                            title: 'Success',
                            message: 'The Tag Was Added',
                            type: 'success'
                        });
                        // Reset the form to prevent double submissions 
                        me.resetForm('tag');
                        // Redirect to the list page
                        me.$router.push({ name: 'ProductTagList'});
                        }, response => {
                            console.log('Error posting data');
                            console.log(response.status);
                            console.log(response.statusText);
                        }
                    );
                    } else {
                        console.log('Fields Not Valid');
                        return false;
                    }
                });
            },

            resetForm(formName) {
                const me = this;
                this.$refs[formName].resetFields();
            }


        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/product-tags/ProductTagAdd.vue